import { Theme, ThemeOptions } from "@mui/material";

/**
 * A blank theme in case customer theme fails to install in src/customer.
 *
 * @param base Base MUI Theme object
 * @returns MUI ThemeOptions
 */
const getCustomerTheme = (base: Theme): ThemeOptions => ({});

export default getCustomerTheme;
